import { useIntl } from "react-intl";
import { useShallow } from "zustand/react/shallow";

import { IntlMessageId } from "shared/lang";
import { CtaModal } from "ui/CtaModal";
import { BodyM } from "ui/Typography/Typography";

import { useTGTGBagStore } from "../stores/useTGTGBagStore";

interface ProductNotEligibleModalProps {
  isOpen: boolean;
}

export function ProductNotEligibleModal({ isOpen }: ProductNotEligibleModalProps) {
  const intl = useIntl();
  const { notEligibleProductName, bagKey, setShowProductNotEligibleModal } = useTGTGBagStore(
    useShallow((state) => ({
      notEligibleProductName: state.notEligibleProductName,
      bagKey: state.bagKey,
      setShowProductNotEligibleModal: state.setShowProductNotEligibleModal,
    })),
  );

  const bagTypeName = bagKey
    ? intl.formatMessage({
        id: `pages.tgtg-bag-selection-page.bag-types.${bagKey}` as IntlMessageId,
      })
    : "";

  const handleClose = () => {
    setShowProductNotEligibleModal(false, null);
  };

  return (
    <CtaModal
      isOpen={isOpen}
      onClose={handleClose}
      hideCloseButton
      title={intl.formatMessage({
        id: "pages.inventory.too-good-to-go.not-eligible-modal.title",
      })}
      body={
        <BodyM textAlign="center" color="grey.700">
          {intl.formatMessage(
            {
              id: "pages.inventory.too-good-to-go.not-eligible-modal.description",
            },
            {
              productName: notEligibleProductName ?? "",
              bagType: bagTypeName,
            },
          )}
        </BodyM>
      }
      ctaLabel={intl.formatMessage({
        id: "pages.inventory.too-good-to-go.not-eligible-modal.cta",
      })}
      onClickCta={handleClose}
    />
  );
}
